<template>
  <div class="container-custom" v-if="projectDetail">
    <!-- breadscrumbs -->
    <div class="breadscrumbs">
      <router-link to="/csr-page" class="breadscrumbs-item"
        >CSR Page</router-link
      >
      <v-icon>chevron_right</v-icon>
      <router-link to="/csr-page/edit" class="breadscrumbs-item"
        >Edit</router-link
      >
      <v-icon>chevron_right</v-icon>
      <a class="breadscrumbs-item active">CSR Project Showcase Edit</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯 CSR Page</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>

    <!-- block -->
    <div class="block mb-5">
      <!-- ProjectTitle -->
      <div class="form-item pt-5 d-flex">
        <label class="w-240px mr-5"
          ><h4>Project Title</h4></label
        >
        <div class="my-n2 flex-grow-1">
          <v-text-field
            v-model="projectDetail.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- Tab -->
      <div class="form-item pt-5 d-flex">
        <label class="w-240px mr-5"><h4>Tab</h4></label>
        <div class="my-n2 flex-grow-1">
          <v-autocomplete
            v-model="projectDetail.csr_project_filter_id"
            class="w-240px"
            :items="tabs"
            item-text="title"
            item-value="id"
            outlined
            dense
          >
          </v-autocomplete>
        </div>
      </div>
      <!-- img uploader -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Project Image</h4>
          <div class="h5 ink-02-medium--text">
            呈現於CSR Page <br />
            建議尺寸：500px*475px <br />
            檔案大小限制：≤20MB <br />
            支援格式：.png/.jpg/.gif
          </div>
        </div>
        <div class="d-flex flex-grow-1">
          <ImgUploader
            :imageUrl.sync="projectDetail.image"
            dir="csr"></ImgUploader>
        </div>
      </div>
    </div>

    <!-- projectFilterCreater -->
    <ProjectFilterCreater
      :isShow="isProjectFilterCreaterShow"
      @close-creater="isProjectFilterCreaterShow = false"
    ></ProjectFilterCreater>

    <div class="page-divider mb-5"></div>

    <!-- content -->
    <div class="d-flex">
      <!-- content head -->
      <div class="w-300px mr-5">
        <h3 class="mb-10px">Content</h3>
        <div class="h4">
          至少需填寫一組 <br />
          於前台左圖右字、右圖左字交錯排版
        </div>
      </div>
      <div class="flex-grow-1">
        <!-- content body -->
        <div class="block mb-5" v-for="(item, i) in projectDetail.content" :key="i">
          <!-- content -->
          <div
            class="form-item py-5 d-flex align-center justify-lg-space-between"
          >
            <h4>Content</h4>
            <button
              v-if="i > 0"
              class="btn btn-danger square w-32px h-32px"
              @click="deleteItem(item)"
            >
              <v-icon color="white">delete</v-icon>
            </button>
          </div>
          <!-- Title -->
          <label class="form-item d-flex pt-5">
            <h4 class="w-160px mr-5">Title</h4>
            <div class="my-n2 flex-grow-1">
              <v-text-field
                v-model="item.title"
                outlined
                dense
              ></v-text-field>
            </div>
          </label>
          <!-- Description -->
          <label class="form-item d-flex py-5">
            <h4 class="w-160px mr-5">Description</h4>
            <div class="my-n2 flex-grow-1">
              <v-textarea
                v-model="item.description"
                outlined
                dense
              ></v-textarea>
            </div>
          </label>
          <!-- img uploader -->
          <div class="form-item d-flex px-5 py-5">
            <div class="w-180px">
              <h4 class="mb-10px">Visual</h4>
              <div class="h5 ink-02-medium--text">
                建議尺寸：999px * 999px <br />
                檔案大小限制：&lt; 1 MB
              </div>
            </div>
            <div class="d-flex justify-end flex-grow-1">
              <ImgUploader
                :imageUrl.sync="item.visual"
                dir="csr"></ImgUploader>
            </div>
          </div>
        </div>
        <!-- add Content Section -->
        <div class="mt-5 mb-9">
          <button class="btn btn-outlined w-100 justify-start" @click="addItem">
            <v-icon class="primary--text mr-2">add_circle</v-icon>
            <span>添加Content Section</span>
          </button>
        </div>
        <div class="page-actions">
          <v-spacer></v-spacer>
          <button class="btn mr-5" @click="cancelHandler">
            <span>取消</span>
          </button>
          <button class="btn btn-primary" @click="saveHandler">
            <span>儲存</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ImgUploader from '@/components/ImgUploader.vue';
import ProjectFilterCreater from '@/views/B-4__CSRPage/c/B-4-1-2-1a-1__CSR-ProjectShowcasePageEdit_ProjectFilter-Create.vue';

export default {
  components: {
    ImgUploader,
    ProjectFilterCreater,
  },
  data: () => ({
    isProjectFilterCreaterShow: false,
    tab: '',
  }),
  computed: {
    ...mapState('csr', ['csr', 'projectDetail', 'tabs']),
  },
  async created() {
    await this.getTabs();
  },
  methods: {
    ...mapActions('csr', [
      'getTabs',
      'setProjectDetail',
      'saveProject',
      'clear',
    ]),
    addItem() {
      const template = {
        title: '',
        description: '',
        visual: '',
      };
      this.projectDetail.content.push(template);
    },
    deleteItem(item) {
      const index = this.projectDetail.content.map((i) => i.id).indexOf(item.id);
      this.projectDetail.content.splice(index, 1);
    },
    cancelHandler() {
      this.$router.go(-1);
    },
    async saveHandler() {
      if (this.csr == null) {
        await this.saveProject(this.projectDetail).then(() => {
          this.clear();
        });
      } else {
        this.setProjectDetail(this.projectDetail);
      }
      this.$router.go(-1);
    },
  },
};
</script>

<style></style>
